export default "__VITE_ASSET__3cac4788__"